import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=2e25004a&"
import script from "./FormList.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports